import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { IButton, TranslateService } from '@devinforius/i-essentials';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-qr-code-modal',
  templateUrl: './qr-code-modal.component.html',
  styleUrls: ['./qr-code-modal.component.scss'],
})
export class QrCodeModalComponent implements OnInit {
  public QRForm = new UntypedFormGroup({
    texte: new UntypedFormControl(null),
    width: new UntypedFormControl(null),
    height: new UntypedFormControl(null),
    dpiX: new UntypedFormControl(null),
    dpiY: new UntypedFormControl(null),
  });

  public titleButtons: IButton[] = [
    {
      text: 'cancel',
      styleClass: 'blue',
      click: () => {
        this.dialogRef.close();
      },
    },
    {
      text: 'confirm',
      styleClass: 'green',
      click: () => {
        this.dialogRef.close(this.QRForm.value);
      },
    },
  ];

  constructor(
    public dialogRef: DynamicDialogRef,
    private translater: TranslateService
  ) {}

  ngOnInit(): void {
    this.titleButtons = this.titleButtons.map((button) => ({ ...button, text: this.translater.translate(button.text) }));
  }
}
